export const ICO_ITERATIONS = 4;
export const MIN_HEIGHT = 1.0;
export const MAX_HEIGHT = 3.0;
export const HEIGHT_RANGE = MAX_HEIGHT - MIN_HEIGHT;
export const ATMOSPHERE_MIN_HEIGHT = 1.0;
export const ATMOSPHERE_MAX_HEIGHT = 5.0;
export const ATMOSPHERE_HEIGHT_RANGE = ATMOSPHERE_MAX_HEIGHT - ATMOSPHERE_MIN_HEIGHT;
export const UNIQUE_FACES = 20 * Math.pow(4, ICO_ITERATIONS);
export const UNIQUE_EDGES = 30 * Math.pow(4, ICO_ITERATIONS);
export const UNIQUE_VERTICES = UNIQUE_EDGES - UNIQUE_FACES + 2;
export const COLOR_PALETTE_SIZE = 15;
